module.exports = __webpack_public_path__ + "img/40_69_006_090.e6c54e46.jpg";